import { useEffect, useState } from "react";

export function useScrollThreshold(threshold: number): boolean {
  const [passedThreshold, setPassedThreshold] = useState(false);

  useEffect(() => {
    const update = () => setPassedThreshold(window.scrollY > threshold);

    update();
    window.addEventListener("scroll", update, { passive: true });

    return () => {
      window.removeEventListener("scroll", update);
    };
  }, [threshold]);

  return passedThreshold;
}
